import * as React from 'react';
import { getColumnPos, renderColumnTitle, getColumnKey } from '../util';
import Input from '../../input';
import useSyncState from './useSyncState';
// export interface FilterState<RecordType> {
//   column: ColumnType<RecordType>;
//   key: Key;
//   filteredKeys?: Key[] | null;
//   forceFiltered?: boolean;
// }
function collectFilterStates(columns, init, pos) {
    let filterStates = [];
    (columns || []).forEach((column, index) => {
        const columnPos = getColumnPos(index, pos);
        if ('children' in column) {
            filterStates = [...filterStates, ...collectFilterStates(column.children, init, columnPos)];
        }
        else {
            // filterStates.push({
            //     column,
            //     key: getColumnKey(column, columnPos),
            //     filterComponent: column.filterComponent,
            //     filteredKeys:
            //         init && column.defaultFilteredValue ? column.defaultFilteredValue! : undefined,
            //     forceFiltered: column.filtered,
            // });
            if ('filteredValue' in column) {
                // Controlled
                filterStates.push({
                    column,
                    key: getColumnKey(column, columnPos),
                    filteredKeys: column.filteredValue,
                    forceFiltered: column.filtered,
                });
            }
            else {
                // Uncontrolled
                filterStates.push({
                    column,
                    key: getColumnKey(column, columnPos),
                    filteredKeys: init && column.defaultFilteredValue ? column.defaultFilteredValue : undefined,
                    forceFiltered: column.filtered,
                });
            }
        }
    });
    return filterStates;
}
function injectFilter(prefixCls, dropdownPrefixCls, columns, filterStates, triggerFilter, getPopupContainer, locale, pos, inlineFilterVisble, inlineFilter) {
    return columns.map((column, index) => {
        const columnPos = getColumnPos(index, pos);
        if (inlineFilter) {
            return Object.assign(Object.assign({}, column), { title: (renderProps) => {
                    return (<InlineFilterWrapper renderProps={renderProps} column={column} inlineFilterVisble={inlineFilterVisble} filterPrefixCls={dropdownPrefixCls} columns={columns} filterStates={filterStates} triggerFilter={triggerFilter} locale={locale} index={index}/>);
                } });
        }
        if ('children' in column) {
            return Object.assign(Object.assign({}, column), { children: injectFilter(prefixCls, dropdownPrefixCls, column.children, filterStates, triggerFilter, getPopupContainer, locale, columnPos, inlineFilterVisble) });
        }
        return column;
    });
}
function generateFilterInfo(filterStates) {
    const currentFilters = {};
    filterStates.forEach(({ key, filteredKeys }) => {
        currentFilters[key] = filteredKeys || null;
    });
    return currentFilters;
}
function flattenKeys(filters) {
    let keys = [];
    (filters || []).forEach(({ value, children }) => {
        keys.push(value);
        if (children) {
            keys = [...keys, ...flattenKeys(children)];
        }
    });
    return keys;
}
export function getFilterData(data, filterStates) {
    return filterStates.reduce((currentData, filterState) => {
        const { column: { onFilter, filters }, filteredKeys, } = filterState;
        if (onFilter && filteredKeys && filteredKeys.length) {
            return currentData.filter(record => filteredKeys.some(key => {
                const keys = flattenKeys(filters);
                const keyIndex = keys.findIndex(k => String(k) === String(key));
                const realKey = keyIndex !== -1 ? keys[keyIndex] : key;
                return onFilter(realKey, record);
            }));
        }
        return currentData;
    }, data);
}
function useFilter({ prefixCls, dropdownPrefixCls, columns, onFilterChange, getPopupContainer, locale: tableLocale, inlineFilterVisble, inlineFilter, }) {
    const [filterStates, setFilterStates] = React.useState(collectFilterStates(columns, true));
    const mergedFilterStates = React.useMemo(() => {
        const collectedStates = collectFilterStates(columns, false);
        // Return if not controlled
        if (collectedStates.every(({ filteredKeys }) => filteredKeys === undefined)) {
            return filterStates;
        }
        return collectedStates;
    }, [columns, filterStates]);
    const triggerFilter = (filterState) => {
        const newFilterStates = mergedFilterStates.filter(({ key }) => key !== filterState.key);
        newFilterStates.push(filterState);
        setFilterStates(newFilterStates);
        onFilterChange(generateFilterInfo(newFilterStates), newFilterStates);
    };
    const transformColumns = (innerColumns) => injectFilter(prefixCls, dropdownPrefixCls, innerColumns, mergedFilterStates, triggerFilter, getPopupContainer, tableLocale, undefined, inlineFilterVisble, inlineFilter);
    return [transformColumns];
}
function InlineFilterWrapper({ index, pos, column, filterStates, inlineFilterVisble, filterPrefixCls, triggerFilter, }) {
    const columnPos = getColumnPos(index, pos);
    const columnKey = getColumnKey(column, columnPos);
    const filterState = filterStates.find(({ key }) => columnKey === key);
    // // ===================== Select Keys =====================
    const propFilteredKeys = (filterState && filterState.filteredKeys) || [];
    const [getFilteredKeysSync, setFilteredKeysSync] = useSyncState(propFilteredKeys || []);
    // React.useEffect(() => {
    //     setFilteredKeysSync(propFilteredKeys);
    // }, [propFilteredKeys])
    const onSelectKeys = ({ selectedKeys }) => {
        setFilteredKeysSync(selectedKeys);
        const mergedKeys = selectedKeys && selectedKeys.length ? selectedKeys : null;
        if (mergedKeys === null && (!filterState || !filterState.filteredKeys)) {
            return null;
        }
        triggerFilter({
            column,
            key: columnKey,
            filteredKeys: mergedKeys,
        });
    };
    // React.useEffect(() => {
    //     onSelectKeys({ selectedKeys: propFilteredKeys || [] });
    // }, [propFilteredKeys]);
    const defautInput = ({ setSelectedKeys, selectedKeys, }) => {
        if (filterState) {
            return (<Input placeholder="输入筛选" onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])} value={selectedKeys[0]}/>);
        }
        else {
            return null;
        }
    };
    let searchNode;
    let filterComponent = defautInput;
    if ('filterComponent' in column) {
        filterComponent = column.filterComponent;
    }
    if (typeof filterComponent === 'function') {
        searchNode = filterComponent({
            prefixCls: `${filterPrefixCls}-custom`,
            setSelectedKeys: (selectedKeys) => onSelectKeys({ selectedKeys }),
            selectedKeys: getFilteredKeysSync(),
            confirm: () => { },
            clearFilters: () => { },
            filters: column.filters,
            visible: inlineFilterVisble || false,
        });
    }
    else if (filterComponent) {
        searchNode = filterComponent;
    }
    return (<div>
      {renderColumnTitle(column.title, {})}
      <div style={{
        paddingTop: 10,
        marginBottom: -10,
        display: inlineFilterVisble ? 'block' : 'none',
    }} onClick={e => e.stopPropagation()}>
        {searchNode}
      </div>
    </div>);
}
export default useFilter;
